export default function slugify(inbound: string): string {
    return inbound
        .toLowerCase()
        .replace(/[^-a-z]/g, '-')
        .replace(/[-]{2,}/g, '-')
        .replace(/[-]$/, '');
}